var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hideNav
    ? _c("section", { staticClass: "account-nav" }, [
        _c("h1", { staticClass: "account-nav__name" }, [
          _vm._v("Hello " + _vm._s(_vm.customerName)),
        ]),
        _c("p", { staticClass: "account-nav__email" }, [
          _vm._v(_vm._s(_vm.customerEmail)),
        ]),
        _c(
          "a",
          {
            staticClass: "account-nav__logout",
            attrs: { href: "/account/logout" },
          },
          [_vm._v("Log Out")]
        ),
        ["mobile", "tablet"].includes(_vm.$mq)
          ? _c(
              "div",
              { staticClass: "account-nav__select input input--select" },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected,
                        expression: "selected",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selected = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.options, function (option) {
                    return _c(
                      "option",
                      { key: option.value, domProps: { value: option.value } },
                      [_vm._v(_vm._s(option.label))]
                    )
                  }),
                  0
                ),
                _c("icon", { attrs: { name: "chevron-down", size: "16px" } }),
              ],
              1
            )
          : _c(
              "ul",
              { staticClass: "account-nav__list u-list-simple" },
              _vm._l(_vm.options, function (option) {
                return _c(
                  "li",
                  {
                    staticClass: "account-nav__list-item",
                    class: { "item-active": _vm.isActive(option.value) },
                  },
                  [
                    _c("a", { attrs: { href: option.value } }, [
                      _vm._v(_vm._s(option.label)),
                    ]),
                  ]
                )
              }),
              0
            ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }